import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {ClsConfig} from '../../../../util/cls-config';
import { OverlaySettings } from '@infragistics/igniteui-angular/core';
import {IGX_SELECT_DIRECTIVES, IgxSelectComponent, IgxSelectItemComponent} from '@infragistics/igniteui-angular/select';
import {FormsModule} from '@angular/forms';
import {ClsObjGenerico} from "../../../../clases-pu/util/cls-obj-generico";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {ClsUtil} from "../../../../util/cls-util";
import {AppPresupuestosService} from "../../../../core/services/app-presupuestos.service";

@Component({
  selector: 'app-select-moneda',
  templateUrl: './select-moneda.component.html',
  styleUrls: ['./select-moneda.component.scss'],
  imports: [
    IGX_SELECT_DIRECTIVES,
    FormsModule,
    IgxSelectComponent,
    IgxSelectItemComponent
  ]
})
export class SelectMonedaComponent extends ClsConfig {
  private tipoMsg = inject(TipoMensajesService);
  private infPpto = inject(AppPresupuestosService);

  @Input()
  public selectedMoneda: string;
  @Input()
  public monedas: string[] = [];
  @Input()
  public overlaySettings: OverlaySettings = this.overlaySettingsCenterBottom;
  @Input()
  public width = '120px';

  @Output()
  public selectionChanging: EventEmitter<any> = new EventEmitter<any>();

  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  constructor() {
    super();
  }

  public async obtenerMonedas() {
    try {
      const idPpto: bigint = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
      this.monedas = await this.mObjGenerico.obtnerCatalogoMonedas(idPpto);
      // Establece el valor seleccionado como el primero de la lista
      this.selectedMoneda = this.monedas[0];
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async handleSelection(e: any) {
    this.selectionChanging.emit(e);
  }
}
